class HorizontalTabs extends HTMLElement {
  constructor() {
    super();
    this.initializedToggles = new WeakSet();
    this._inited = false;
  }

  connectedCallback() {
    if (this._inited) return;
    this._inited = true;

    const tabs = Array.from(this.querySelectorAll('[slot="tab"]'));
    const contents = Array.from(this.querySelectorAll('[slot="content"]'));
    if (!tabs.length || !contents.length) return;

    const initTogglesIn = (container) => {
      if (!container) return;

      // Find buttons inside this tab content
      const toggles = container.querySelectorAll('[data-js-toggle]');
      if (!toggles.length) return; // ⚡ Skip entirely if no toggle buttons exist

      // Ensure Pristine's Toggle utility exists
      const Toggle = window.themeCore?.utils?.Toggle;
      if (typeof Toggle !== 'function') return;

      toggles.forEach((btn) => {
        if (!btn || this.initializedToggles.has(btn)) return;

        try {
          const selector =
            btn.dataset.jsToggle ||
            btn.getAttribute('data-js-toggle') ||
            btn.dataset.target;

          const instance = Toggle({ toggleSelector: selector });
          if (typeof instance.init === 'function') instance.init({ once: true });

          this.initializedToggles.add(btn);
        } catch (err) {
          console.warn('HorizontalTabs: failed to init Toggle for', btn, err);
        }
      });
    };

    // 🟢 Handle tab clicks
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.target;
        tabs.forEach((t) => t.classList.remove('active'));
        contents.forEach((c) => c.classList.remove('active'));

        tab.classList.add('active');
        const target = this.querySelector(`#${targetId}`);
        if (target) {
          target.classList.add('active');
          initTogglesIn(target); // Initialize toggles for this content only once
        }
      });
    });

    // 🟢 Initialize toggles inside the default active tab
    const activeContent =
      this.querySelector('[slot="content"].active') || contents[0];
    initTogglesIn(activeContent);
  }
}

customElements.define('horizontal-tabs', HorizontalTabs);